module.exports = __webpack_public_path__ + "static/media/logo_large981b8908.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo_large.svg
// module id = 661
// module chunks = 0